"use client";

import { LoginModal } from "@/components/auth/login-modal";
import { SerieVideoPremiumWarningModal } from "@/components/serie-video-premium-warning-modal";
import { SeriesDetailParams, useSeriesDetail } from "../use-series-detail";
import type { RecommendationsConfig } from "./types";
import { VideoDetailLayout } from "./video-detail-layout";
import { VideoDetailLoading, VideoDetailNotFound } from "./video-detail-states";

export type SeriesVideoDetailViewProps = SeriesDetailParams & {
    recommendations?: RecommendationsConfig;
};

export function SeriesVideoDetailView({
    params,
    searchParams,
    recommendations,
}: SeriesVideoDetailViewProps) {
    const {
        session,
        isPremium,
        series,
        isLoading,
        isBooked,
        toggleBookmark,
        timeStamp,
        autoPlay,
        modalToggle,
        isLoginModalOpen,
        setIsLoginModalOpen,
        currentVideo,
        handleSelection,
        handleLoginSuccess,
        handleEnd,
    } = useSeriesDetail({ params, searchParams });

    if (isLoading) {
        return <VideoDetailLoading />;
    }

    if (!series?.Videos) {
        return <VideoDetailNotFound />;
    }

    const isLoggedIn = Boolean(session?.user);
    const onLoginRequest = () => setIsLoginModalOpen(true);
    const videoTitle = currentVideo?.Title ?? series.Title;
    const descriptionHtml =
        currentVideo?.Description ?? series.Videos[0]?.Description ?? "";

    return (
        <VideoDetailLayout
            isLoggedIn={isLoggedIn}
            onLoginRequest={onLoginRequest}
            videoTitle={videoTitle}
            descriptionHtml={descriptionHtml}
            currentVideo={currentVideo}
            seekTime={timeStamp ? Number(timeStamp) : undefined}
            autoPlay={autoPlay}
            onEnd={handleEnd}
            videoTrainer={series.VideoTrainer}
            seriesId={series.Id}
            bookmarkCount={series._count?.UserSeries ?? 0}
            isBookmarked={isBooked(series.Id)}
            onBookmark={() => void toggleBookmark(series.Id)}
            seriesTitle={series.Title}
            videos={series.Videos}
            currentVideoId={currentVideo?.Id}
            isPremium={isPremium}
            onSelect={handleSelection}
            recommendations={recommendations}
            modals={
                <>
                    <SerieVideoPremiumWarningModal isOpen={modalToggle} />
                    <LoginModal
                        open={isLoginModalOpen}
                        onOpenChange={setIsLoginModalOpen}
                        onSuccess={handleLoginSuccess}
                    />
                </>
            }
        />
    );
}
